let queue = [];

self.addEventListener(
  "message",
  function (e) {
    // Add the message to the queue
    queue.push(e.data);

    // If the worker isn't currently processing a message, start processing
    if (queue.length === 1) {
      processNextMessage();
    }
  },
  false
);

function processNextMessage() {
  if (queue.length === 0) {
    return;
  }

  const dataFromMain = queue[0];

  switch (dataFromMain.action) {
    case "fetchReviewsFromJunip":
      fetchReviewsFromJunip(dataFromMain).then((d) => {
        // Remove the message from the queue and process the next message
        queue.shift();
        processNextMessage();
      })
      .catch((error) => {
        queue.shift();
        processNextMessage();
      });
      break;
    case "fetchProductFromShopify":
      fetchProductFromShopify(dataFromMain).then(() => {
        queue.shift();
        processNextMessage();
      }).catch((error) => {
        queue.shift();
        processNextMessage();
      });
      break;
    default:
      self.postMessage({ error: "Unknown action type" });
      queue.shift();
      processNextMessage();
      break;
  }
}

function fetchReviewsFromJunip(data) {
  return new Promise((resolve, reject) => {
    const baseUrl = "https://api.juniphq.com/v1/product_reviews";

    const dataParams = {
      productRemoteId: data.productRemoteId,
      versionKey: data.versionKey,
    };

    const params = {
      include: "product,customer,store,respondent,survey_answers,tik_tok_urls",
      "filter[rating]": 5,
      "sort[field]": "featured",
      "sort[order]": "desc",
      "page[size]": 3,
      "filter[product_remote_ids][]": dataParams.productRemoteId,
      v: dataParams.versionKey,
    };

    const url = new URL(baseUrl);
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    fetch(url, {
      method: "GET",
      headers: {
        "Junip-Store-Key": dataParams.versionKey,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        self.postMessage({
          ...data,
          action: "fetchReviewsFromJunip",
          productRemoteId: dataParams.productRemoteId,
        });
        resolve();
      })
      .catch((error) => {
        self.postMessage({
          action: "fetchReviewsFromJunip",
          error: error.message,
        });
        reject(error);
      });
  });
}

function fetchProductFromShopify(inputData) {
  return new Promise(async (resolve, reject) => {
    if (!inputData.url) {
      reject({ message: 'URL is required' });
      return;
    }

    if (!inputData.handle) {
      reject({ message: 'Handle is required' });
      return;
    }

    try {
      const response = await fetch(inputData.url);
      if (response.status === 404) {
        throw {
          message: "Product not found",
          status: 404,
        };
      }
      const data = await response.json();
      self.postMessage({
        ...data,
        action: "fetchProductFromShopify",
        handle: inputData.handle,
      });
      resolve();
    } catch (error) {
      self.postMessage({
        action: "fetchProductFromShopify",
        error: error.message,
        handle: inputData.handle,
      });
      reject(error);
    }
  });
}
